var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BtnToggle',{attrs:{"title":_vm.$t('engine.manageText.modalWidget.tooltip.lblImage', _vm.languageEngine)},on:{"click":_vm.chooseImage,"click_":function($event){return _vm.addImage()}}},[_c('i',{staticClass:"far fa-image fs-16"})])}
var staticRenderFns = []

export { render, staticRenderFns }